import Vue from 'vue';
import Router from 'vue-router';
import KillListPage from '@/views/KillListPage.vue';
import HistoryPage from '@/views/HistoryPage.vue';
import MyPlatformsPage from '@/views/MyPlatformsPage.vue';
import GamesPage from '@/views/GamesPage.vue';
import GamePage from '@/views/GamePage.vue';
import HomePage from '@/views/HomePage';
import MyGamesPage from '@/views/MyGamesPage';
import PlatformsPage from '@/views/PlatformsPage';
import PlatformPage from '@/views/PlatformPage';
import RecommendationsPage from '@/views/RecommendationsPage';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage,
    },
    {
      path: '/kill-list',
      name: 'kill-list',
      component: KillListPage,
    },
    {
      path: '/players/:id/recommendations',
      name: 'my-recommendations',
      component: RecommendationsPage,
    },
    {
      path: '/history',
      name: 'history',
      component: HistoryPage,
    },
    {
      path: '/platforms/:platform',
      name: 'platform',
      component: PlatformPage,
    },
    {
      path: '/games/:id',
      name: 'game',
      alias: '/platforms/:platform/games/:id',
      component: GamePage,
    },
    {
      path: '/players/:id/platforms',
      name: 'my-platforms',
      component: MyPlatformsPage,
    },
    {
      path: '/players/:id/games',
      name: 'my-games',
      component: MyGamesPage,
    },
    {
      path: '/platforms',
      name: 'platforms',
      component: PlatformsPage,
    },
    {
      path: '/games',
      name: 'games',
      component: GamesPage,
    },
    {
      path: '/redirect',
      name: 'redirect',
      component: HomePage,
    },
  ],
});
